type AnalyticsParameters = Record<string, unknown>;

const SESSION_STORAGE_KEY = "marginglow_product_session_id";

function getProductSessionId() {
  try {
    const existing = window.localStorage.getItem(SESSION_STORAGE_KEY);

    if (existing) {
      return existing;
    }

    const randomPart =
      typeof window.crypto?.randomUUID === "function"
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const sessionId = `mg_${randomPart}`;

    window.localStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    return sessionId;
  } catch {
    return `mg_${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

export function trackPublicEvent(
  eventName: string,
  parameters: AnalyticsParameters = {},
) {
  if (typeof window === "undefined") {
    return;
  }

  window.gtag?.("event", eventName, parameters);

  void fetch("/api/product-events", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      eventName,
      anonymousSessionId: getProductSessionId(),
      parameters,
      pagePath: window.location.pathname,
      referrerDomain: (() => {
        try {
          return document.referrer ? new URL(document.referrer).hostname : "";
        } catch {
          return "";
        }
      })(),
      clientCreatedAt: new Date().toISOString(),
    }),
    keepalive: true,
  }).catch(() => {
    // First-party analytics must never interrupt the visitor experience.
  });
}
